import './page/search-log-list';

Shopware.Module.register('topdata-es-search-log', {
    type: 'plugin',
    name: 'SearchLog',
    title: 'TopdataEnhancedSearchSW6.topdata-es-search-log.title',
    description: 'TopdataEnhancedSearchSW6.topdata-es-search-log.description',
    color: '#189eff',
    icon: 'default-shopping-search',

    routes: {
        list: {
            component: 'topdata-es-search-log-list',
            path: 'list',
            meta: {
                privilege: 'system.zero_search.viewer',
            },
        },
    },

    navigation: [{
        id: 'topdata-es-search-log',
        parent: 'topdata-es',
        label: 'TopdataEnhancedSearchSW6.topdata-es-search-log.title',
        path: 'topdata.es.search.log.list',
        icon: 'default-shopping-search',
        privilege: 'system.zero_search.viewer',
    }],
});
